import { paramsToString } from '@/services/http/httpClient'
import billmaHttpClient from '@/services/http/billmaHttpClient'

/* eslint-disable */
export const apiGetFlowData = sinisterId => {
  const params = new URLSearchParams()
  params.set('claimID', sinisterId)

  return billmaHttpClient
    .get(`/machine/api/claim/state${paramsToString(params)}`)
}

export const apiGetTransitionToNextState = (sinisterId, event, options) => {
  const params = new URLSearchParams()
  params.set('claimID', sinisterId)

  if (event) params.set('event', event)
  if (options) {
    Object.keys(options).forEach(option => {
      params.set(option, options[option])
    })
  }
  return billmaHttpClient
    .get(`/machine/api/claim/state/next${paramsToString(params)}`)
}
